module.exports = __webpack_public_path__ + "assets/img/warrior-name-9b5e6410.png";